@if (banners$ | async; as banners) {
  @let shouldTurnOnCarousel = isMoreThanOne(banners);

  <p-carousel
    [showNavigators]="shouldTurnOnCarousel"
    [autoplayInterval]="5000"
    [circular]="shouldTurnOnCarousel"
    [numScroll]="1"
    [numVisible]="1"
    [showIndicators]="shouldTurnOnCarousel"
    [value]="banners">
    <ng-template
      #item
      let-banner>
      <app-public-brand-banner-carousel-item
        [bannerId]="banner.id"
        [externalLink]="banner.url"
        [imageAlt]="banner.file.alt"
        [imageSrc]="banner.file.url"
        [mobileImageSrc]="banner.smallFile?.url"
        [slug]="slug()" />
    </ng-template>
  </p-carousel>
} @else {
  <div class="px-8 pb-8 xl:px-16">
    <app-spinner-filled />
  </div>
}
